<template lang="pug">
#bloco-pesquisa-inteligente-filtros-contrato
    .filtros
        .pesquisa-inteligente__container
            .pesquisa-inteligente__barra-pesquisa
                i.el-icon-search
                input(
                    v-model='pesquisa',
                    type='text',
                    :placeholder='placeholderComCodigoExterno()',
                    autocomplete='off',
                    @keyup.enter='aplicarFiltros',
                    @input='limpar'
                )

        .filtros-data
            el-date-picker.input-data-cadastro(
                v-model='dataSelecionada',
                type='daterange',
                range-separator='-',
                format='dd/MM/yyyy',
                :clearable='false',
                :start-placeholder='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.dataInicio")',
                :end-placeholder='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.dataFim")',
                size='large',
                @change='aplicarFiltros'
            )

        .filtros-avancados
            el-popover(placement='bottom', width='600', trigger='click')
                el-button.button-outline(
                    icon='lyra-icon lyra-filtro',
                    name='filtro',
                    plain,
                    slot='reference'
                ) {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.filtrosAvancados') }}

                el-form.filtro-contrato(label-position='top')
                    .filtros-avancados__titulo
                        p {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.filtrosAvancados') }}

                    .filtros-avancados__collapse
                        el-collapse(v-model='collapse', accordion)
                            el-collapse-item(
                                v-if='this.usuarioLogado.ambienteLogado === "BR"',
                                :title='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.tituloCanal")',
                                name='canal'
                            )
                                el-checkbox-group.filtros-avancados__opcoes(
                                    v-model='canalSelecionado',
                                    v-loading='carregandoCanal'
                                )
                                    el-checkbox(
                                        v-for='canal in canais',
                                        :label='canal.nome',
                                        :key='canal.nome + canal.id',
                                        :value='canal.id',
                                        @change='aplicarFiltros'
                                    ) {{ canal.nome }}

                            el-collapse-item(
                                :title='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.tituloCultura")',
                                name='cultura'
                            )
                                el-checkbox-group.filtros-avancados__opcoes(
                                    v-model='culturaSelecionada',
                                    v-loading='carregandoCultura'
                                )
                                    el-checkbox(
                                        v-for='cultura in culturas',
                                        :label='cultura.nome',
                                        :key='cultura.nome + cultura.id',
                                        :value='cultura.id',
                                        @change='aplicarFiltros'
                                    ) {{ cultura.nome }}

                            el-collapse-item(
                                :title='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.tituloFornecedor")',
                                name='fornecedor'
                            )
                                p.sub-titulo {{ $t('mensagens.subEmpresaGestao.filtrosAvancados.selectFornecedores') }}
                                el-select#fornecedor(
                                    v-model='fornecedorSelecionado',
                                    multiple,
                                    :loading='carregandoFornecedor',
                                    :disabled='!fornecedorSelecionado',
                                    clearable,
                                    filterable,
                                    collapse-tags,
                                    @change='aplicarFiltros',
                                    @clear='removerFiltro(fornecedorSelecionado)'
                                )
                                    el-option(
                                        v-for='fornecedor in fornecedores',
                                        :label='fornecedor.nome',
                                        :key='fornecedor.nome + fornecedor.id',
                                        :value='fornecedor.nome'
                                    )

                            el-collapse-item(
                                v-if='this.usuarioLogado.ambienteLogado === "BR"',
                                :title='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.tituloSegmento")',
                                name='segmento'
                            )
                                el-checkbox-group.filtros-avancados__opcoes(
                                    v-model='segmentoSelecionado',
                                    v-loading='carregandoSegmento'
                                )
                                    el-checkbox(
                                        v-for='segmento in segmentos',
                                        :label='segmento.nome',
                                        :key='segmento.nome + segmento.id',
                                        :value='segmento.id',
                                        @change='aplicarFiltros'
                                    ) {{ segmento.nome }}

                            el-collapse-item(
                                v-if='this.usuarioLogado.ambienteLogado === "BR"',
                                :title='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.tituloRegional")',
                                name='regional'
                            )
                                el-checkbox-group.filtros-avancados__opcoes(
                                    v-model='regionalSelecionado',
                                    v-loading='carregandoRegional'
                                )
                                    el-checkbox(
                                        v-for='regional in regionais',
                                        :label='regional.nome',
                                        :key='regional.nome + regional.id',
                                        :value='regional.id',
                                        @change='aplicarFiltros'
                                    ) {{ regional.nome }}

                            el-collapse-item(
                                :title='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.tituloSafra")',
                                name='safra'
                            )
                                el-checkbox-group.filtros-avancados__opcoes(
                                    v-model='safraSelecionada',
                                    v-loading='carregandoSafra'
                                )
                                    el-checkbox(
                                        v-for='safra in safras',
                                        :label='safra.ano',
                                        :key='safra.ano + safra.id',
                                        :value='safra.id',
                                        @change='aplicarFiltros'
                                    ) {{ safra.ano }}

                            el-collapse-item(
                                :title='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.tituloStatus")',
                                name='status'
                            )
                                el-checkbox-group.filtros-avancados__opcoes(
                                    v-model='statusSelecionado',
                                    v-loading='carregandoStatusEmpresa'
                                )
                                    el-checkbox(
                                        v-for='status in statusEmpresa',
                                        :label='status.codigo',
                                        :key='status.descricao + status.codigo',
                                        :value='status.codigo',
                                        @change='aplicarFiltros'
                                    ) {{ $t(`mensagens.subEmpresaGestao.status.${status.codigo}`) }}

                            el-collapse-item(
                                v-if='isUsuarioLDC',
                                title='Trading',
                                name='subTrading'
                            )
                                el-checkbox-group.filtros-avancados__opcoes(
                                    v-model='subTradingSelecionado',
                                    v-loading='carregandoSubTrading'
                                )
                                    el-checkbox(
                                        v-for='subTrading in subTradings',
                                        :label='subTrading.nome',
                                        :key='subTrading.nome + subTrading.id',
                                        :value='subTrading.id',
                                        @change='aplicarFiltros'
                                    ) {{ subTrading.nome }}

                            el-collapse-item(
                                v-if='this.usuarioLogado.ambienteLogado === "BR"',
                                title='EUDR',
                                name='eudr'
                            )
                                el-select(
                                    v-model='eudrSelecionado',
                                    :placeholder='$t("mensagens.comuns.selecione")',
                                    filterable,
                                    @change='aplicarFiltros'
                                )
                                    el-option(
                                        v-for='({ nome, id, value }, index) in eudr',
                                        :key='`eudr-${index}`',
                                        :id='`eudr-${index}`',
                                        :label='nome',
                                        :value='value'
                                    )

    .pesquisa-inteligente-novo-monitoramento__filtros-selecionados.mt-3
        span.filtros-selecionados__titulo(v-if='tags.length') {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.filtrosSelecionados') }}
        el-tag.filtros-selecionados__tags(
            v-for='(tag, index) in tags',
            :key='index',
            closable='',
            type='success',
            @close='removerFiltro(tag)'
        )
            span {{ traducaoStatusFiltro(tag) }}

        el-tag.filtros-selecionados__limpar(
            v-if='tags.length',
            type='info',
            @click='limparFiltros'
        ) {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.limparFiltros') }}
            i.el-icon-delete
</template>

<script>
import ContratoOriginacaoService from '@/services/ContratoOriginacaoService';
import RegionalService from '@/services/RegionalService';
import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';
import { mapState } from 'vuex';

export default {
    name: 'BlocoPesquisaInteligenteFiltros',

    data() {
        return {
            AmbientesEmpresas,
            collapse: null,
            tags: [],
            canalSelecionado: [],
            culturaSelecionada: [],
            segmentoSelecionado: [],
            regionalSelecionado: [],
            safraSelecionada: [],
            statusSelecionado: [],
            subTradingSelecionado: [],
            eudrSelecionado: '',
            numeroContratoSelecionado: [],
            fornecedorSelecionado: [],
            dataSelecionada: '',
            pesquisa: '',
            canais: [],
            culturas: [],
            segmentos: [],
            regionais: [],
            safras: [],
            fornecedores: [],
            subTradings: [],
            carregandoCanal: false,
            carregandoCultura: false,
            carregandoSegmento: false,
            carregandoSafra: false,
            carregandoRegional: false,
            carregandoNumeroContrato: false,
            carregandoFornecedor: false,
            carregandoSubTrading: false,
            eudr: [
                {
                    nome: this.$t('mensagens.comuns.sim'),
                    id: 1,
                    value: true
                },
                {
                    nome: this.$t('mensagens.comuns.nao'),
                    id: 2,
                    value: false
                }
            ]
        };
    },

    props: {
        carregandoStatusEmpresa: {
            type: Boolean,
            required: true
        },
        statusEmpresa: {
            type: Array,
            required: true
        }
    },

    mounted() {
        this.buscarCanais();
        this.buscarCulturas();
        this.buscarSegmentos();
        this.buscarRegionais();
        this.buscarSafras();
        this.buscarStatus();
        this.buscarFornecedor();
        if (this.isUsuarioLDC) {
            this.buscarSubTradings();
        }
    },

    computed: {
        ...mapState(['usuarioLogado']),
        isBe8() {
            const nameGroup = this.usuarioLogado?.nameGroup?.toUpperCase();

            return nameGroup === 'BE8';
        },
        isUsuarioLDC() {
            return this.usuarioLogado?.isLDC === true;
        }
    },

    methods: {
        placeholderComCodigoExterno() {
            const placeholder = this.$t(
                'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.buscar'
            );
            const codigoExterno = this.$t(
                'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.codigoExterno'
            );

            return this.isBe8 ? `${placeholder} ${codigoExterno}` : placeholder;
        },
        handlerTagEudr(value) {
            this.eudrSelecionado = value ? true : '';
            this.aplicarFiltros();
        },
        adicionarTagEudr() {
            const sim = this.$t('mensagens.comuns.sim');
            const nao = this.$t('mensagens.comuns.nao');
            const eudrTagSim = `EUDR: ${sim}`;
            const eudrTagNao = `EUDR: ${nao}`;

            const tagJaAdicionada = this.tags.some(
                tag => tag === eudrTagSim || tag === eudrTagNao
            );

            if (!tagJaAdicionada) {
                this.tags.push(`EUDR: ${this.eudrSelecionado ? sim : nao}`);
            }
        },
        removerTagEudr() {
            const sim = this.$t('mensagens.comuns.sim');
            const nao = this.$t('mensagens.comuns.nao');
            const eudrTagSim = `EUDR: ${sim}`;
            const eudrTagNao = `EUDR: ${nao}`;

            this.tags = this.tags.filter(
                tag => tag !== eudrTagSim && tag !== eudrTagNao
            );
        },
        aplicarFiltros() {
            this.tags = [];
            if (this.culturaSelecionada.length) {
                this.tags.push(...this.culturaSelecionada);
            }
            if (this.safras.length) this.tags.push(...this.safraSelecionada);

            if (this.dataSelecionada && this.dataSelecionada.length === 2) {
                const formatarData = dataISO => {
                    const data = new Date(dataISO);
                    const dia = String(data.getDate()).padStart(2, '0');
                    const mes = String(data.getMonth() + 1).padStart(2, '0');
                    const ano = data.getFullYear();
                    return `${dia}/${mes}/${ano}`;
                };

                const dataInicio = formatarData(this.dataSelecionada[0]);
                const dataFim = formatarData(this.dataSelecionada[1]);

                const intervaloFormatado = `${dataInicio} - ${dataFim}`;
                this.tags.push(intervaloFormatado);
            }

            if (this.canalSelecionado.length) {
                this.tags.push(...this.canalSelecionado);
            }
            if (this.segmentoSelecionado.length) {
                this.tags.push(...this.segmentoSelecionado);
            }
            if (this.regionalSelecionado.length) {
                this.tags.push(...this.regionalSelecionado);
            }
            if (this.statusSelecionado.length) {
                this.tags.push(...this.statusSelecionado);
            }
            if (this.fornecedorSelecionado.length) {
                this.tags.push(...this.fornecedorSelecionado);
            }
            if (this.subTradingSelecionado.length) {
                this.tags.push(...this.subTradingSelecionado);
            }

            if (this.eudrSelecionado !== '') {
                this.adicionarTagEudr();
            }

            const filtro = {
                canais: this.obterIdsCanal(),
                culturas: this.obterIdsCultura(),
                segmentos: this.obterIdsSegmento(),
                regionais: this.obterIdsRegional(),
                safras: this.obterIdsSafra(),
                status: this.obterIdsStatus(),
                dataCadastroInicio: this.converterData(this.dataSelecionada[0]),
                dataCadastroFim: this.converterData(this.dataSelecionada[1]),
                pesquisa: this.obterPesquisa(),
                fornecedores: this.obterIdFonecedor(),
                eudr: this.eudrSelecionado,
                subTradings: this.obterIdsSubTrading()
            };
            this.$emit('emitFiltros', filtro);
        },
        inserirFiltrosStatus(filtro) {
            const codigo = filtro.codigo;

            this.statusSelecionado.push(codigo);
            this.aplicarFiltros();
        },
        removerFiltroStatus(filtro) {
            const codigo = filtro.codigo;

            this.statusSelecionado.splice(
                this.statusSelecionado.indexOf(codigo),
                1
            );
            this.aplicarFiltros();
        },
        removerFiltro(filtro) {
            this.tags.splice(this.tags.indexOf(filtro), 1);
            this.desmarcarFiltroPopover(filtro);
            this.aplicarFiltros();
        },
        converterData(date) {
            if (!this.dataSelecionada.length) return '';
            return new Date(date).getTime();
        },
        mapearParaValores(selecionados, opcoes, campoBusca, campoRetorno) {
            if (!selecionados) return [];
            return selecionados
                .map(valorSelecionado => {
                    const opcao = opcoes.find(
                        item => item[campoBusca] === valorSelecionado
                    );
                    return opcao ? opcao[campoRetorno] : null;
                })
                .filter(valor => valor !== null);
        },
        obterIdsStatus() {
            return this.mapearParaValores(
                this.statusSelecionado,
                this.statusEmpresa,
                'codigo',
                'codigo'
            );
        },
        obterIdsCultura() {
            return this.mapearParaValores(
                this.culturaSelecionada,
                this.culturas,
                'nome',
                'id'
            );
        },
        obterIdsSafra() {
            return this.mapearParaValores(
                this.safraSelecionada,
                this.safras,
                'ano',
                'id'
            );
        },
        obterIdsCanal() {
            return this.mapearParaValores(
                this.canalSelecionado,
                this.canais,
                'nome',
                'id'
            );
        },
        obterIdsSegmento() {
            return this.mapearParaValores(
                this.segmentoSelecionado,
                this.segmentos,
                'nome',
                'id'
            );
        },
        obterIdsRegional() {
            return this.mapearParaValores(
                this.regionalSelecionado,
                this.regionais,
                'nome',
                'id'
            );
        },

        obterPesquisa() {
            if (!this.pesquisa) return '';
            return this.pesquisa;
        },
        limparFiltros() {
            this.tags = [];
            this.canalSelecionado = [];
            this.culturaSelecionada = [];
            this.segmentoSelecionado = [];
            this.regionalSelecionado = [];
            this.safraSelecionada = [];
            this.statusSelecionado = [];
            this.fornecedorSelecionado = [];
            this.subTradingSelecionado = [];
            this.dataSelecionada = '';
            this.pesquisa = '';
            this.eudrSelecionado = '';
            this.aplicarFiltros();
        },

        traducaoStatusFiltro(tag) {
            const statusSelecionado = this.statusEmpresa.find(
                status => status.codigo === tag
            );
            if (statusSelecionado) {
                return this.$t(`mensagens.subEmpresaGestao.status.${tag}`);
            }

            return tag;
        },

        desmarcarFiltroPopover(filtro) {
            const indexCanais = this.canalSelecionado.indexOf(filtro);
            if (indexCanais !== -1) {
                this.canalSelecionado.splice(indexCanais, 1);
            }

            const indexCultura = this.culturaSelecionada.indexOf(filtro);
            if (indexCultura !== -1) {
                this.culturaSelecionada.splice(indexCultura, 1);
            }

            const indexSafra = this.safraSelecionada.indexOf(filtro);
            if (indexSafra !== -1) {
                this.safraSelecionada.splice(indexSafra, 1);
            }

            const indexStatus = this.statusSelecionado.indexOf(filtro);
            if (indexStatus !== -1) {
                this.statusSelecionado.splice(indexStatus, 1);
            }

            const indexSegmentos = this.segmentoSelecionado.indexOf(filtro);
            if (indexSegmentos !== -1) {
                this.segmentoSelecionado.splice(indexSegmentos, 1);
            }

            const indexRegionais = this.regionalSelecionado.indexOf(filtro);
            if (indexRegionais !== -1) {
                this.regionalSelecionado.splice(indexRegionais, 1);
            }

            const regexData = /^\d{2}\/\d{2}\/\d{4} - \d{2}\/\d{2}\/\d{4}$/;
            if (regexData.test(filtro)) {
                this.dataSelecionada = '';
            }

            const filtroEudr = filtro.includes('EUDR');
            if (filtroEudr) {
                this.removerTagEudr();
                this.eudrSelecionado = '';
            }

            const indexFornecedor = this.fornecedorSelecionado.indexOf(filtro);
            if (indexFornecedor !== -1) {
                this.fornecedorSelecionado.splice(indexFornecedor, 1);
            }

            const indexSubTrading = this.subTradingSelecionado.indexOf(filtro);
            if (indexSubTrading !== -1) {
                this.subTradingSelecionado.splice(indexSubTrading, 1);
            }
        },
        formatarData(data, formatDate) {
            if (data) {
                const dia = formatDate(data, 'dd');
                const mes = formatDate(data, 'MM');
                const ano = formatDate(data, 'yyyy');
                return `${dia}, ${mes}, ${ano}`;
            }
            return '';
        },
        limpar() {
            if (this.pesquisa === '') this.aplicarFiltros();
        },

        async buscarCanais() {
            try {
                this.carregandoCanal = true;
                const { data } = await ContratoOriginacaoService.buscarCanais();
                this.canais = data;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarCanal'
                    )
                );
            }
            this.carregandoCanal = false;
        },

        async buscarCulturas() {
            this.carregandoCultura = true;
            try {
                const { data } = await ContratoOriginacaoService.buscarCulturas();
                
                this.culturas = data;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarCultura'
                    )
                );
            }
            this.carregandoCultura = false;
        },

        async buscarSegmentos() {
            try {
                this.carregandoSegmento = true;
                const { data } =
                    await ContratoOriginacaoService.buscarSegmentos();

                this.segmentos = data;
                this.carregandoSegmento = false;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarSegmento'
                    )
                );
            }
        },

        async buscarRegionais() {
            try {
                this.carregandoRegional = true;
                const { data } = await RegionalService.buscarRegionais();

                this.regionais = data;
                this.carregandoRegional = false;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarRegional'
                    )
                );
            }
        },

        async buscarSafras() {
            try {
                this.carregandoSafra = true;
                const { data } = await ContratoOriginacaoService.buscarSafras();

                const safrasOrdenadas = data.sort((a, b) => a.ano - b.ano);
                this.safras = safrasOrdenadas;
                this.carregandoSafra = false;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarSafra'
                    )
                );
            }
        },

        async buscarStatus() {
            const status = this.statusEmpresa;
            this.$emit('emitStatus', status);
        },

        async buscarFornecedor() {
            this.carregandoFornecedor = true;
            try {
                const { data } =
                    await ContratoOriginacaoService.buscarBpClientes();
                this.fornecedores = data;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarFornecedor'
                    )
                );
            }
            this.carregandoFornecedor = false;
        },

        obterIdFonecedor() {
            if (!this.fornecedorSelecionado) return [];
            return this.fornecedorSelecionado.map(nome => {
                const statusObjeto = this.fornecedores.find(
                    objeto => objeto.nome === nome
                );
                return statusObjeto ? statusObjeto.id : null;
            });
        },

        async buscarSubTradings() {
            try {
                this.carregandoSubTrading = true;
                const { data } = await ContratoOriginacaoService.buscarSubTradings();
                this.subTradings = data;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarSubTrading'
                    )
                );
            }
            this.carregandoSubTrading = false;
        },

        obterIdsSubTrading() {
            return this.mapearParaValores(
                this.subTradingSelecionado,
                this.subTradings,
                'nome',
                'id'
            );
        }
    },

    watch: {
        statusEmpresa: {
            handler(newValue, oldValue) {
                if (newValue) {
                    this.buscarStatus();
                }
            },
            immediate: true
        }
    }
};
</script>

<style lang="scss">
body {
    overflow-y: hidden;
    overflow-x: hidden;
}

#bloco-pesquisa-inteligente-filtros-contrato {
    .filtros {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        gap: 10px;
    }

    .pesquisa-inteligente__container {
        width: 100%;
        height: 42px;
        border-radius: 5px;
        background: var(--white);
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
        position: relative;
    }

    .filtros-data {
        box-shadow: 0px 0px 10px rgb(0 0 0 / 10%);
    }

    .input-data-cadastro {
        height: 43px !important;

        .el-input__inner {
            height: 43px !important;
        }
    }

    .pesquisa-inteligente__barra-pesquisa {
        height: 100%;
        display: flex;
        justify-content: center;

        i.el-icon-search {
            color: var(--gray);
            font-size: 16px;
            display: flex;
            align-items: center;
            margin: 0 8px;
        }

        input {
            width: 100%;
            height: 100%;
            border: none;
            outline: none;
            border-radius: 5px;
            color: var(--primary);
        }
    }

    .pesquisa-inteligente__resultado {
        position: absolute;
        width: 100%;
    }

    .pesquisa-inteligente__ul {
        list-style: none;
        padding: 8px 0 8px 24px;
        position: relative;
        z-index: 42;
        margin-top: 5px;
        border-radius: 5px;
        background-color: var(--white);
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);

        li {
            padding-left: 18px;
            margin-top: 5px;
            cursor: pointer;
        }
    }

    .pesquisa-inteligente__categoria {
        font-weight: bold;
    }

    .pesquisa-inteligente-novo-monitoramento__filtros-selecionados {
        display: flex;
        align-items: center;
        gap: 4px;
        flex-wrap: wrap;
    }

    .filtros-selecionados__limpar {
        cursor: pointer;
    }
}

.filtros-avancados__titulo {
    color: var(--primary);
    font-weight: bold;
}

.filtros-avancados__opcoes {
    font-size: 0;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    max-height: 150px;
    overflow-y: auto;
    overflow-x: hidden;
    @include scroll-bar(4px, 4px, var(--primary));
}

.fornecedor {
    .el-collapse-item__content {
        padding-bottom: 25px;
        font-size: 13px;
        color: #303133;
        line-height: 1.7692307692;
        max-height: 202px;
        overflow-y: auto;
        overflow-x: auto;
        display: flex;
        flex-direction: column;
        padding: 0px;
    }
}
</style>
